import { HydrationEffects } from '@app/core/store/hydration/hydration.effects';
import { Type } from '@angular/core';

export const rootEffects: Type<any>[] = [HydrationEffects];
